import { getDocument } from '../utils';
export var computeItemHeight = function (treeId) {
    var _a;
    var firstItem = (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.querySelector("[data-rct-tree=\"".concat(treeId, "\"] [data-rct-item-container=\"true\"]"));
    if (firstItem) {
        var style = getComputedStyle(firstItem);
        // top margin flows into the bottom margin of the previous item, so ignore it
        return (firstItem.offsetHeight +
            Math.max(parseFloat(style.marginTop), parseFloat(style.marginBottom)));
    }
    return 5;
};
export var isOutsideOfContainer = function (e, treeBb) {
    return e.clientX <= treeBb.left ||
        e.clientX >= treeBb.right ||
        e.clientY <= treeBb.top ||
        e.clientY >= treeBb.bottom;
};
